import { Link } from 'react-router-dom';
import { WEEKLY_ARCHIVE_URL } from '../lib/site';

// The static host serves index.html for any unmatched path, so this is what a
// visitor sees for a bad URL — and also what they would see if a server-rendered
// path (/weekly, /b/<slug>) ever failed to be split off to the backend upstream
// of the SPA container.
export default function NotFound() {
  return (
    <div className="mx-auto max-w-3xl px-5 py-24 text-center">
      <p className="font-mono text-xs uppercase tracking-[0.24em] text-clay">404</p>
      <h1 className="wordmark mt-4 text-3xl font-bold tracking-tight sm:text-4xl">
        Nothing to brief here
      </h1>
      <p className="mt-4 text-base font-light leading-relaxed text-muted">
        That address does not match anything on BriefBlip. Try one of the three rungs.
      </p>

      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link
          to="/meetings"
          className="rounded-lg border border-edge bg-panel/70 px-5 py-2.5 text-sm font-semibold text-ink transition hover:border-teal/50 hover:text-teal"
        >
          Meeting blips
        </Link>
        <Link
          to="/blip"
          className="rounded-lg border border-edge bg-panel/70 px-5 py-2.5 text-sm font-semibold text-ink transition hover:border-teal/50 hover:text-teal"
        >
          Blip a doc
        </Link>
        <a
          href={WEEKLY_ARCHIVE_URL}
          className="rounded-lg border border-edge bg-panel/70 px-5 py-2.5 text-sm font-semibold text-ink transition hover:border-teal/50 hover:text-teal"
        >
          Weekly briefs
        </a>
      </div>
    </div>
  );
}
